import Vue from 'vue'
import Vuex from 'vuex'

import configModule from '@/../../shared/src/store/modules/config'
import loggerModule from '../../../shared/src/store/modules/logger'

import browserModule from './modules/browser.js'
import microphoneModule from './modules/microphone.js'
import cameraModule from './modules/camera.js'
import connectionModule from './modules/connection.js'
import previewModule from './modules/preview.js'
// import twilioModule from './modules/twilio.js'
// import opentokModule from './modules/opentok.js'

import { logFailurePlugin } from './plugins/logFailures'


Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    config: configModule,
    logger: loggerModule,
    microphone: microphoneModule,
    browser: browserModule,
    camera: cameraModule,
    connection: connectionModule,
    preview: previewModule
    // twilio: twilioModule,
    // opentok: opentokModule
  },

  plugins: [ logFailurePlugin() ]
})

export default store
